export const choosing_supplement_9P = [
  {
      Xpos_text: 25,
      Ypos_text: 100,
      page_eng: 15,
      page_thai: 14,
      info: [
          {sp: 'Bifidobacterium bifidum', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Bifidobacterium breve', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Bifidobacterium lactis', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Bifidobacterium longum', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus acidophilus', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus gasseri', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus paracasei', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus reuteri', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus rhamnosus', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus helveticus', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Lactobacillus plantarum', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Streptococcus thermophilus', less: ['Deficient', 'Slightly Deficient']},
          {sp: 'Akkermansia muciniphila', less: ['Deficient', 'Slightly Deficient']},
      ]
  }
]

// Supplement instruction text based on selection and duration
export const supplementInstructions = {
  // Single supplement instructions - only the specific instruction for the selected supplement
  single: {
    'BioAll': 'Consume 2 capsules 30 mins before or after any meal',
    'BioMeta': 'Consume 2 capsules 30 mins before or after breakfast/ lunch',
    'BioZen': 'Consume 2 capsules 30-60 mins before your bed-time',
    'BioGrace': 'Consume 2 capsules 30 mins before or after any meal'
  },
  
  // B2B Single supplement instructions
  singleB2B: {
    'BioAll': 'Consume 2 capsules 30 mins before or after any meal',
    'BioMeta': 'Consume 2 capsules 30 mins before or after breakfast/ lunch',
    'BioZen': 'Consume 2 capsules 30-60 mins before your bed-time',
    'BioGrace': 'Consume 2 capsules 30 mins before or after any meal'
  },
  
  // Thai Single supplement instructions - B2C
  singleThai: {
    'BioAll': 'ทานวันละ 2 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
    'BioMeta': 'ทานวันละ 2 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
    'BioZen': 'ทานวันละ 2 แคปซูล ก่อนเข้านอน 30-60 นาที',
    'BioGrace': 'ทานวันละ 2 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
  },
  
  // Thai B2B Single supplement instructions
  singleThaiB2B: {
    'BioAll': 'ทานวันละ 2 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
    'BioMeta': 'ทานวันละ 2 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
    'BioZen': 'ทานวันละ 2 แคปซูล ก่อนเข้านอน 30-60 นาที',
    'BioGrace': 'ทานวันละ 2 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
  },
  
  // Thai B2B Two supplement combinations
  doubleThaiB2B: {
    'BioAll+BioMeta': {
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน'
    },
    'BioMeta+BioAll': {
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน'
    },
    'BioMeta+BioZen': {
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน'
    },
    'BioZen+BioMeta': {
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน'
    },
    'BioZen+BioAll': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioAll+BioZen': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioAll+BioGrace': {
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioGrace+BioAll': {
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioMeta+BioGrace': {
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioGrace+BioMeta': {
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioZen+BioGrace': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioGrace+BioZen': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    }
  },
  
  // Thai B2B Three supplement combinations
  tripleThaiB2B: {
    '3months': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน เดือนที่ 1, 3',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน เดือนที่ 2, 3',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 3'
    },
    '6months': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน เดือนที่ 1, 3, 4 และ 6',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน เดือนที่ 2, 3, 5 และ 6',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 4 และ 5',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 3, 4, 5 และ 6'
    },
    '12months': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน เดือนที่ 1, 3, 4, 6, 7, 9, 10 และ 12',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน เดือนที่ 2, 3, 5, 6, 8, 9, 11 และ 12',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 4, 5, 7, 8, 10 และ 11',
      'BioGrace': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11 และ 12'
    }
  },
  
  // Thai Two supplement combinations - B2C
  doubleThai: {
    'BioAll+BioMeta': {
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน'
    },
    'BioMeta+BioAll': {
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน'
    },
    'BioMeta+BioZen': {
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน'
    },
    'BioZen+BioMeta': {
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน',
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน'
    },
    'BioZen+BioAll': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    },
    'BioAll+BioZen': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้'
    }
  },
  
  // Two supplement combinations - individual instructions for each supplement
  double: {
    'BioAll+BioMeta': {
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch'
    },
    'BioMeta+BioAll': {
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch'
    },
    'BioMeta+BioZen': {
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch',
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time'
    },
    'BioZen+BioMeta': {
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch',
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time'
    },
    'BioZen+BioAll': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal'
    },
    'BioAll+BioZen': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal'
    }
  },
  
  // B2B Two supplement combinations - individual instructions for each supplement
  doubleB2B: {
    'BioAll+BioMeta': {
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch'
    },
    'BioMeta+BioAll': {
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch'
    },
    'BioMeta+BioZen': {
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch',
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time'
    },
    'BioZen+BioMeta': {
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch',
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time'
    },
    'BioZen+BioAll': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal'
    },
    'BioAll+BioZen': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal'
    }
  },
  
  // Three supplement combinations with duration - individual instructions for each supplement
  triple: {
    '3months': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time, 1st and 3rd month',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch, 2nd and 3rd month',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal, 1st and 2nd month'
    },
    '6months': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time, 1st, 3rd, 4th and 6th month',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch, 2nd, 3rd, 5th and 6th month',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal, 1st, 2nd, 4th and 5th month'
    },
    '12months': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time, 1st, 3rd, 4th, 6th, 7th, 9th, 10th and 12th',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch, 2nd, 3rd, 5th, 6th, 8th, 9th, 11th and 12th',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal, 1st, 2nd, 4th, 5th, 7th, 8th, 10th and 11th'
    }
  },
  
  // B2B Three supplement combinations with duration - individual instructions for each supplement
  tripleB2B: {
    '3months': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time, 1st and 3rd month',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch, 2nd and 3rd month',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal, 1st and 2nd month'
    },
    '6months': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time, 1st, 3rd, 4th and 6th month',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch, 2nd, 3rd, 5th and 6th month',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal, 1st, 2nd, 4th and 5th month'
    },
    '12months': {
      'BioZen': 'Consume 1 capsule 30-60 mins before your bed-time, 1st, 3rd, 4th, 6th, 7th, 9th, 10th and 12th',
      'BioMeta': 'Consume 1 capsule 30 mins before or after breakfast/ lunch, 2nd, 3rd, 5th, 6th, 8th, 9th, 11th and 12th',
      'BioAll': 'Consume 1 capsule 30 mins before or after any meal, 1st, 2nd, 4th, 5th, 7th, 8th, 10th and 11th'
    }
  },
  
  // Thai Three supplement combinations with duration - B2C
  tripleThai: {
    '3months': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน เดือนที่ 1, 3',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน เดือนที่ 2, 3',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2'
    },
    '6months': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน เดือนที่ 1, 3, 4 และ 6',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน เดือนที่ 2, 3, 5 และ 6',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 4 และ 5'
    },
    '12months': {
      'BioZen': 'ทานวันละ 1 แคปซูล 30-60 นาที ก่อนเข้านอน เดือนที่ 1, 3, 4, 6, 7, 9, 10 และ 12',
      'BioMeta': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารเช้า/ กลางวัน เดือนที่ 2, 3, 5, 6, 8, 9, 11 และ 12',
      'BioAll': 'ทานวันละ 1 แคปซูล 30 นาที ก่อน หรือหลังอาหารมื้อใดก็ได้ เดือนที่ 1, 2, 4, 5, 7, 8, 10 และ 11'
    }
  }
};

// Function to get instruction text based on selected supplements and duration
export const getSupplementInstruction = (selectedSupplements, duration = null, currentSupplement = null, isB2B = false, isThai = false, dateOfBirth = null) => {
  // Auto-add BioGrace for clients 45+ years old
  const finalSupplements = addBioGraceIfNeeded(selectedSupplements, dateOfBirth);
  console.log('Final supplements after BioGrace check:', finalSupplements);
  
  // Use original selectedSupplements for instruction logic, but finalSupplements for key generation
  const originalSupplements = selectedSupplements.filter(supp => supp !== 'BioGrace');
  const sortedSupplements = originalSupplements.sort();
  const supplementKey = sortedSupplements.join('+');
  
  console.log('=== getSupplementInstruction DEBUG ===');
  console.log('Input - selectedSupplements:', selectedSupplements);
  console.log('Input - originalSupplements (for logic):', originalSupplements);
  console.log('Input - finalSupplements (for display):', finalSupplements);
  console.log('Input - duration:', duration);
  console.log('Input - currentSupplement:', currentSupplement);
  console.log('Input - dateOfBirth:', dateOfBirth);
  console.log('Calculated - supplementKey:', supplementKey);
  
  if (originalSupplements.length === 1) {
    let instructionSet;
    if (isThai && isB2B) {
      instructionSet = supplementInstructions.singleThaiB2B;
    } else if (isThai) {
      instructionSet = supplementInstructions.singleThai;
    } else if (isB2B) {
      instructionSet = supplementInstructions.singleB2B;
    } else {
      instructionSet = supplementInstructions.single;
    }
    const result = instructionSet[currentSupplement] || '';
    console.log('Single supplement result:', result);
    return result;
  } else if (originalSupplements.length === 2) {
    // Two-supplement dosing does NOT depend on duration — `double` is a flat
    // supplement -> text map — so return it regardless of the duration format.
    // (The previous version gated on a hardcoded duration whitelist and returned
    // "" for formats like "1 months"/"2 months"/"3", hiding the detail.)
    if (currentSupplement) {
      let instructionSet;
      if (isThai && isB2B) {
        instructionSet = supplementInstructions.doubleThaiB2B;
      } else if (isThai) {
        instructionSet = supplementInstructions.doubleThai;
      } else if (isB2B) {
        instructionSet = supplementInstructions.doubleB2B;
      } else {
        instructionSet = supplementInstructions.double;
      }
      const result = instructionSet[supplementKey]?.[currentSupplement] || '';
      console.log('Two supplement result:', result);
      return result;
    }
    console.log('Two supplement - no valid instruction found');
    return '';
  } else if (originalSupplements.length === 3) {
    // For three supplements, return the instruction for the specific supplement being displayed
    let durationKey = '3months'; // default
    
    if (duration) {
      // Handle different duration formats
      if (duration === '3 months' || duration === 3) {
        durationKey = '3months';
      } else if (duration === '6 months' || duration === 6) {
        durationKey = '6months';
      } else if (duration === '12 months' || duration === 12) {
        durationKey = '12months';
      } else {
        // Try to extract number from duration string
        const match = duration.toString().match(/(\d+)/);
        if (match) {
          durationKey = `${match[1]}months`;
        }
      }
    }
    
    console.log('Three supplement - duration:', duration);
    console.log('Three supplement - durationKey:', durationKey);
    console.log('Three supplement - available keys:', Object.keys(supplementInstructions.triple));
    
    if (currentSupplement) {
      let instructionSet;
      if (isThai && isB2B) {
        instructionSet = supplementInstructions.tripleThaiB2B;
      } else if (isThai) {
        instructionSet = supplementInstructions.tripleThai;
      } else if (isB2B) {
        instructionSet = supplementInstructions.tripleB2B;
      } else {
        instructionSet = supplementInstructions.triple;
      }
      // Only 3/6/12-month schedules exist; any other duration (e.g. "1 months",
      // "2 months") falls back to the 3-month schedule so the detail is not blank.
      if (!instructionSet[durationKey]) {
        durationKey = '3months';
      }
      const result = instructionSet[durationKey]?.[currentSupplement] || '';
      console.log('Three supplement result:', result);
      return result;
    }
    console.log('Three supplement - no valid instruction found');
    return '';
  }
  
  console.log('No matching condition found');
  return '';
};

export const supplement_bacteria_map_9P = {
    'A01-BBI': {
      'Bifidobacterium bifidum': 100
    },
    'A02-BBR': {
      'Bifidobacterium breve': 100
    },
    'A03-BLA': {
      'Bifidobacterium lactis': 100
    },
    'A04-BLO': {
      'Bifidobacterium longum': 100
    },
    'A05-LAC': {
      'Lactobacillus acidophilus': 100
    },
    'A06-LGA': {
      'Lactobacillus gasseri': 100
    },
    'A07-LPA': {
      'Lactobacillus paracasei': 100
    },
    'A08-LRE': {
      'Lactobacillus reuteri': 100
    },
    'A09-LRH': {
      'Lactobacillus rhamnosus': 100
    },
    'B01-LHE': {
      'Lactobacillus helveticus': 100
    },
    'B02-LPL': {
      'Lactobacillus plantarum': 100
    },
    'B03-STH': {
      'Streptococcus thermophilus': 100
    },
    'B04-AMU': {
      'Akkermansia muciniphila': 100
    }
};

// ---------------------------------------------------------------------------
// New-formula 9P products (single-strain SKUs).
// Artwork: webappbio-frontend/public/supplement/newformula/<SKU>.png (500x500).
// There is no separate Thai artwork for these SKUs, so both language configs
// point at the same files and only differ by the page they render on.
// ---------------------------------------------------------------------------
export const supplement_9P_skus = [
  'A01-BBI',
  'A02-BBR',
  'A03-BLA',
  'A04-BLO',
  'A05-LAC',
  'A06-LGA',
  'A07-LPA',
  'A08-LRE',
  'A09-LRH',
  'B01-LHE',
  'B02-LPL',
  'B03-STH',
  'B04-AMU'
];

// Tile size used when the SKUs are laid out as a grid on the supplement page.
const SKU_TILE_WIDTH = 150;

const build_supplement_images_9P = (page) =>
  supplement_9P_skus.reduce((acc, sku) => {
    acc[sku] = {
      image_name: `newformula/${sku}`,
      page,
      x: 160,
      y: 560,
      width: SKU_TILE_WIDTH,
      height: 'auto'
      // No `text` block: dosing instructions are not defined for the new
      // formula yet, and PdfStaticModal skips the text layer when it is absent.
    };
    return acc;
  }, {});

export const supplement_images9P_eng = build_supplement_images_9P(15);

export const supplement_images9P_thai = build_supplement_images_9P(14);

// ===========================================================================
// ORIGINAL (legacy) 9P formula — BioAll / BioMeta / BioZen / BioGrace.
// Selectable from the CSV Import Preview "Calculation" toggle. Everything below
// is the pre-single-strain behavior, kept verbatim so it can be switched back
// on without disturbing the new-formula defaults above.
// ===========================================================================

// Legacy panel: the original 9 evaluated species.
export const choosing_supplement_9P_old = [
  {
    Xpos_text: 25,
    Ypos_text: 100,
    page_eng: 15,
    page_thai: 14,
    info: [
      { sp: 'Bifidobacterium bifidum', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Bifidobacterium breve', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Bifidobacterium lactis', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Bifidobacterium longum', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Lactobacillus acidophilus', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Lactobacillus gasseri', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Lactobacillus paracasei', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Lactobacillus reuteri', less: ['Deficient', 'Slightly Deficient'] },
      { sp: 'Lactobacillus rhamnosus', less: ['Deficient', 'Slightly Deficient'] }
    ]
  }
];

// Legacy product -> species coverage map (weights 100 / 1000).
// NOTE: 'BIfidobacterium bifidum' and 'BIfidobacterium infantis' keep the
// original capital-I typo on purpose — this reproduces the exact legacy
// behavior (BioAll's bifidum coverage never matched the panel key).
export const supplement_bacteria_map_9P_old = {
  'BioAll': {
    'BIfidobacterium bifidum': 100,
    'Bifidobacterium longum': 100,
    'Lactobacillus gasseri': 100,
    'Lactobacillus paracasei': 100,
    'Lactobacillus reuteri': 1000,
    'Lactobacillus rhamnosus': 1000,
    'Bifidobacterium adolescentis': 1000,
    'BIfidobacterium infantis': 1000
  },
  'BioMeta': {
    'Bifidobacterium breve': 1000,
    'Bifidobacterium lactis': 1000,
    'Lactobacillus gasseri': 1000,
    'Lactobacillus paracasei': 1000,
    'Lactobacillus rhamnosus': 100,
    'Bacillus coagulans': 1000
  },
  'BioZen': {
    'Bifidobacterium bifidum': 1000,
    'Bifidobacterium breve': 100,
    'Bifidobacterium longum': 1000,
    'Lactobacillus acidophilus': 1000,
    'Lactobacillus reuteri': 100
  }
};

// Legacy product artwork configs (flat PNG images with an instruction caption).
export const supplement_images9P_eng_old = {
  'BioAll': {
    image_name: 'bioall', page: 15, x: 160, y: 560, width: 745, height: 'auto',
    text: { content: 'Instruction of Use:', x: 172, y: 679, fontSize: 13, fontWeight: 700, fontFamily: '"Gilroy-Regular", sans-serif', color: '#333333' }
  },
  'BioMeta': {
    image_name: 'biometa', page: 15, x: 160, y: 557, width: 745, height: 'auto',
    text: { content: 'Instruction of Use:', x: 172, y: 650, fontSize: 13, fontWeight: 700, fontFamily: '"Gilroy-Regular", sans-serif', color: '#333333' }
  },
  'BioZen': {
    image_name: 'biozen', page: 15, x: 160, y: 557, width: 745, height: 'auto',
    text: { content: 'Instruction of Use:', x: 172, y: 650, fontSize: 13, fontWeight: 700, fontFamily: '"Gilroy-Regular", sans-serif', color: '#333333' }
  },
  'BioGrace': {
    image_name: 'biograce', page: 15, x: 160, y: 560, width: 745, height: 'auto',
    text: { content: 'Instruction of Use:', x: 172, y: 679, fontSize: 13, fontWeight: 700, fontFamily: '"Gilroy-Regular", sans-serif', color: '#333333' }
  }
};

export const supplement_images9P_thai_old = {
  'BioAll': {
    image_name: 'bioall_thai', page: 14, x: 160, y: 560, width: 745, height: 'auto',
    text: { content: 'วิธีรับประทาน:', x: 172, y: 679, fontSize: 13, fontWeight: 600, fontFamily: '"Noto Sans Thai", sans-serif', color: '#333333' }
  },
  'BioMeta': {
    image_name: 'biometa_thai', page: 14, x: 160, y: 560, width: 745, height: 'auto',
    text: { content: 'วิธีรับประทาน:', x: 172, y: 650, fontSize: 13, fontWeight: 700, fontFamily: '"Noto Sans Thai", sans-serif', color: '#333333' }
  },
  'BioZen': {
    image_name: 'biozen_thai', page: 14, x: 160, y: 560, width: 745, height: 'auto',
    text: { content: 'วิธีรับประทาน:', x: 172, y: 650, fontSize: 13, fontWeight: 700, fontFamily: '"Noto Sans Thai", sans-serif', color: '#333333' }
  },
  'BioGrace': {
    image_name: 'biograce_thai', page: 14, x: 160, y: 560, width: 745, height: 'auto',
    text: { content: 'วิธีรับประทาน:', x: 172, y: 679, fontSize: 13, fontWeight: 700, fontFamily: '"Noto Sans Thai", sans-serif', color: '#333333' }
  }
};

// Function to calculate age from date of birth
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return 0;
  
  // Handle different date formats: "1/1/1930", "01/01/1930", etc.
  let birthDate;
  
  if (typeof dateOfBirth === 'string') {
    // Parse date string in format "M/D/YYYY", "MM/DD/YYYY", "DD/MM/YYYY", or "D/M/YYYY"
    const dateParts = dateOfBirth.split('/');
    if (dateParts.length === 3) {
      const part1 = parseInt(dateParts[0], 10);
      const part2 = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);
      
      // Determine if it's DD/MM/YYYY or MM/DD/YYYY format
      // If part1 > 12, it's likely DD/MM/YYYY format
      let month, day;
      if (part1 > 12) {
        // DD/MM/YYYY format
        day = part1;
        month = part2;
      } else if (part2 > 12) {
        // MM/DD/YYYY format
        month = part1;
        day = part2;
      } else {
        // Ambiguous case - assume MM/DD/YYYY for dates like 1/1/1930
        month = part1;
        day = part2;
      }
      
      birthDate = new Date(year, month - 1, day); // month is 0-indexed in Date constructor
    } else {
      return 0;
    }
  } else if (dateOfBirth instanceof Date) {
    birthDate = dateOfBirth;
  } else {
    return 0;
  }
  
  // Check if date is valid
  if (isNaN(birthDate.getTime())) {
    return 0;
  }
  
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  // Adjust age if birthday hasn't occurred this year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

// BioGrace is not part of the new 9P formula, so the age 45+ auto-add is
// disabled. Kept as a pass-through because DashboardPage, PdfStaticModal and
// getSupplementInstruction still call it.
export const addBioGraceIfNeeded = (selectedSupplements, dateOfBirth) => {
  return selectedSupplements;
};

// Legacy rule: auto-append BioGrace (kept last) for clients aged 45+.
export const addBioGraceIfNeeded_old = (selectedSupplements, dateOfBirth) => {
  if (!selectedSupplements || !Array.isArray(selectedSupplements)) {
    return selectedSupplements;
  }
  const age = calculateAge(dateOfBirth);
  if (age >= 45 && !selectedSupplements.includes('BioGrace')) {
    const withoutBioGrace = selectedSupplements.filter((s) => s !== 'BioGrace');
    return [...withoutBioGrace, 'BioGrace'];
  }
  if (selectedSupplements.includes('BioGrace')) {
    const withoutBioGrace = selectedSupplements.filter((s) => s !== 'BioGrace');
    return [...withoutBioGrace, 'BioGrace'];
  }
  return selectedSupplements;
};

// Function to get the final supplement list with BioGrace auto-inclusion
export const getFinalSupplementList = (selectedSupplements, dateOfBirth) => {
  return addBioGraceIfNeeded(selectedSupplements, dateOfBirth);
};
